import React from "react";
import Typewriter from "typewriter-effect";
import Zoom from "react-reveal/Zoom";

import star from "./graphics/star.png";

function Experience() {
  return (
    <div id="experience" name="experience">
      <div className="experience-content">
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString("Exp()")
              .pauseFor(2000)
              .deleteAll()
              .deleteAll()
              .start();
          }}
          options={{ loop: true, cursor: "_" }}
        />
        <Zoom duration={700}>
          <div className="experience-container">
            <article className="experience-block">
              <h3>
                <img src={star} alt="" /> Stripe
              </h3>
              <div className="experience-role">
                <p>
                  Software Engineer |{" "}
                  <span className="location">New York, NY</span>
                </p>
                <p className="experience-dates">Feb 2023 - Present</p>
              </div>
              <div className="experience-role">
                <p>
                  Software Engineer Intern |{" "}
                  <span className="location">Seattle, WA</span>
                </p>
                <p className="experience-dates">May 2022 - Jul 2022</p>
              </div>
            </article>

            <article className="experience-block">
              <h3>
                <img src={star} alt="" /> TikTok (Bytedance)
              </h3>
              <div className="experience-role">
                <p>
                  Software Engineer Intern |{" "}
                  <span className="location">Mountain View, CA</span>
                </p>
                <p className="experience-dates">May 2021 - Aug 2021</p>
              </div>
            </article>

            <article className="experience-block">
              <h3>
                <img src={star} alt="" /> Duke Database Group
              </h3>
              <div className="experience-role">
                <p>
                  Student Software Developer |{" "}
                  <span className="location">Durham, NC</span>
                </p>
                <p className="experience-dates">Jan 2021 - Present</p>
              </div>
            </article>

            <a
              href="https://www.linkedin.com/in/jameszleong/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin" />
            </a>
          </div>
        </Zoom>
      </div>
    </div>
  );
}

export default Experience;
